import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LaCheckboxGroupOptionInterface } from './la-checkbox-group-option.interface';

@Component({
  selector: 'la-checkbox-group',
  template: `
    <div class="la-checkbox-group">
      <la-filter-button *ngFor="let option of options" [value]="option.value"
                        [option]="option"
                        (onSelected)="onBtnSelected($event)"
                        (onDeselected)="onBtnDeselected($event)">{{option.label}}</la-filter-button>
    </div>
  `,
  styles: [`
    .la-checkbox-group{display:flex}.la-checkbox-group .la-radio-button{margin-right:8px}.la-checkbox-group la-radio-button:last-child{margin-right:-8px}
  `],
  encapsulation: ViewEncapsulation.None,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: LaCheckboxGroupComponent,
    // useExisting: forwardRef(() => LaCheckboxGroupComponent),
    multi: true
  }],
})
export class LaCheckboxGroupComponent implements ControlValueAccessor {
  onChange: Function;
  onTouch: Function;
  private _optionsMap: { [key: string]: LaCheckboxGroupOptionInterface };
  private _value: any[] = [];

  private _options: LaCheckboxGroupOptionInterface[] = [];

  @Input()
  get options(): LaCheckboxGroupOptionInterface[] {
    return this._options;
  }

  set options(opts: LaCheckboxGroupOptionInterface[]) {
    if (!Array.isArray(opts)) {
      return;
    }
    this._options = opts;

    // create a map to fast search particular options by value
    this._optionsMap = opts.reduce((acc, val) => {
      acc[val.value] = val;
      return acc;
    }, {});

    // calculate form control value
    this._value = opts.reduce((acc, val) => {
      if (val.isActive) {
        acc.push(val.value);
      }
      return acc;
    }, []);
    // notify form control
    if (this.onChange) {
      this.onChange(this._value);
    }
  }

  //
  // ControlValueAccessor Interface Methods
  //

  // Here we get function, which we need to call when we've updated value via

  // custom component UI
  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.onChange(this._value);
  }

  // Here we need notify that user interacted with our Custom component
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // TODO, figure out how to use it
  setDisabledState(isDisabled: boolean): void {
  }

  // Update custom component UI value, after form control changed via setValue method
  writeValue(newValues: any[]): void {
    if (!Array.isArray(newValues)) {
      return;
    }
    this._value = newValues;
    this.options.forEach(opt => {
      opt.isActive = false;
    });
    newValues.forEach(val => {
      if (this._optionsMap[val] !== undefined) {
        this._optionsMap[val].isActive = true;
      }
    });
  }

  //
  // Component own methods
  //

  onBtnSelected(value: any) {
    this._value.push(value);
    // notify form control about changes
    this.onChange(this._value);
  }

  onBtnDeselected(value: any) {
    // remove current value from the list
    const newArr = this._value.filter(search => search !== value);
    // remove values which looks false
    this._value = newArr.filter(search => !!search);
    // notify form control about changes
    this.onChange(this._value);
  }
}
